import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDocument, getDocumentTemplate } from '_services/documents';

interface ExportState {
  university: string;
  faculty: string;
  title: string;
  subtitle: string;
  discipline: string;
  author: string;
  research_director: string;
  school_year: string;
  abbreviations: any[];
  index: any[];
  thanks: string;
  logo: string;
  summary_level: number;
}

export const initialState: ExportState = {
  university: '',
  faculty: '',
  title: '',
  subtitle: '',
  discipline: '',
  author: '',
  research_director: '',
  school_year: '',
  abbreviations: [],
  index: [],
  thanks: '',
  logo: ',',
  summary_level: 2
};


const exportModalSlice = createSlice({
  name: 'exportModal',
  initialState,
  reducers: {
    exportReset: (state) => {
      for (const key of Object.keys(initialState)) {
        state[key] = initialState[key];
      }
    },
    exportSet: (state, action: PayloadAction<any>) => {
      for (const key of Object.keys(action.payload)) {
        state[key] = action.payload[key]
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(getDocument.matchFulfilled, (state, action) => {
      
      const payload: any = action.payload;
      for (const key of Object.keys(initialState)) {
        if (payload[key])
          state[key] = payload[key]
      }

    }).addMatcher(getDocumentTemplate.matchFulfilled, (state, action) => {
      const payload: any = action.payload;
      for (const key of Object.keys(initialState)) {
        if (payload[key]) {
          state[key] = payload[key]
        }
      }
    })
  }
});

export const {
  exportSet,
  exportReset
} = exportModalSlice.actions;

export default exportModalSlice.reducer;
